import { api } from "./api";

export interface ApiUser {
  id: string;
  cognito_sub: string;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  is_active: boolean;
}

export interface CreateUserPayload {
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  temporary_password: string;
}

export interface AdminUpdateUserPayload {
  first_name?: string;
  last_name?: string;
  role?: string;
  is_active?: boolean;
}

export const usersApi = {
  me: async (): Promise<ApiUser> => {
    return api.get<ApiUser>("/api/auth/me");
  },

  list: async (): Promise<ApiUser[]> => {
    return api.get<ApiUser[]>("/api/users");
  },

  adminCreate: async (payload: CreateUserPayload): Promise<ApiUser> => {
    return api.post<ApiUser>("/api/admin/users", payload);
  },

  adminUpdate: async (userId: string, payload: AdminUpdateUserPayload): Promise<ApiUser> => {
    return api.put<ApiUser>(`/api/admin/users/${userId}`, payload);
  },

  syncRoles: async (): Promise<{ updated: number }> => {
    return api.post<{ updated: number }>("/api/admin/users/sync-roles", {});
  },
};
